import React, { Component } from "react";

export default class RujukBalik extends Component {
  render() {
    return (
      <div>
        <div>
          <br />
          <table
            style={{
              fontSize: "11pt"
            }}
            width={"99%"}
            frame={"box"}
          >
            <tbody>
              <tr>
                <td align="center" colSpan={5}>
                  <u>
                    <h3>SURAT RUJUKAN BALIK</h3>
                  </u>
                </td>
              </tr>
              <tr>
                <td colSpan={5}>Teman sejawat Yth.</td>
              </tr>
              <tr>
                <td colSpan={5}>Mohon kontrol selanjutnya penderita :</td>
              </tr>
              <tr>
                <td style={{ width: 40 }}>&nbsp;</td>
                <td>Nama </td>
                <td colSpan={3}>: {this.props.nama}</td>
              </tr>
              <tr>
                <td style={{ width: 40 }}>&nbsp;</td>
                <td>Diagnosa </td>
                <td colSpan={3}>
                  {" "}
                  :
                  .............................................................................................
                </td>
              </tr>
              <tr>
                <td style={{ width: 40 }}>&nbsp;</td>
                <td>Terapi </td>
                <td colSpan={3}>
                  {" "}
                  :
                  .............................................................................................
                </td>
              </tr>
              <tr>
                <td colSpan={5}>Tindak lanjut yang dianjurkan</td>
              </tr>
              <tr>
                <td colSpan={2}>
                  {" "}
                  <input
                    type="text"
                    name="pengobatan"
                    style={{ width: 20 }}
                  />{" "}
                  Pengobatan dengan obat-obatan :
                </td>
                <td colSpan={3}>
                  {" "}
                  <input type="text" name="Pranap" style={{ width: 20 }} />{" "}
                  Perlu rawat inap
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  {" "}
                  ..............................................................................
                </td>
                <td colSpan={3}>
                  {" "}
                  <input
                    type="text"
                    name="Konsultasi_selesai"
                    style={{ width: 20 }}
                  />{" "}
                  Konsultasi Selesai
                </td>
              </tr>
              <tr>
                <td colSpan={5}>
                  {" "}
                  <input
                    type="text"
                    name="kontrolRS"
                    style={{ width: 20 }}
                  />{" "}
                  Kontrol kembali ke RS tanggal :..........................
                </td>
              </tr>
              <tr></tr>
              <tr>
                <td colSpan={5}>
                  {" "}
                  <input
                    type="text"
                    name="lasin_lain"
                    style={{ width: 20 }}
                  />{" "}
                  Lain-Lain:..........................
                </td>
              </tr>
              <tr>
                <td colSpan={5} align="right">
                  ............................tgl....................................&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <br />
                  <br />
                </td>
              </tr>
              <tr>
                <td colSpan={5} align="right">
                  Dokter RS,
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </td>
              </tr>
              <tr>
                <td colSpan={5} align="right">
                  ( ...................................................
                  )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <br />
                  <br />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
